import { render, staticRenderFns } from "./ImprestDashboard.vue?vue&type=template&id=2e02adcf&scoped=true"
import script from "./ImprestDashboard.vue?vue&type=script&lang=js"
export * from "./ImprestDashboard.vue?vue&type=script&lang=js"
import style0 from "./ImprestDashboard.vue?vue&type=style&index=0&id=2e02adcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e02adcf",
  null
  
)

export default component.exports